// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ba_kLWZwpepDF1xjivhi {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-family: var(--curio-font-family);
}

.BFgYnDQZYyDeH9DBhGMU {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--curio-role-installed-fg);
  background-color: var(--curio-role-installed-bg);
  border: 1px solid rgba(47, 143, 74, 0.4);
  border-radius: var(--curio-radius-pill);
  padding: 2px 8px;
  line-height: 1.15;
  white-space: nowrap;
  cursor: pointer;
  font-family: inherit;
}

.BFgYnDQZYyDeH9DBhGMU:hover {
  background-color: rgba(47, 143, 74, 0.22);
  border-color: var(--curio-role-installed-fg);
}

.BFgYnDQZYyDeH9DBhGMU:focus-visible {
  outline: 2px solid var(--curio-role-installed-fg);
  outline-offset: 1px;
}

/* Owning node is selected on the canvas — vibrant solid fill that pops against
   the node header. */
.uL6iGMVYFQ59FiY0J3lR,
.uL6iGMVYFQ59FiY0J3lR:hover {
  color: #ffffff;
  background-color: var(--curio-role-installed-fg);
  border-color: var(--curio-role-installed-fg);
  box-shadow: 0 0 0 2px rgba(47, 143, 74, 0.35);
}

.OWiS2iuririxKxzOTLQo {
  font-size: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/DatasetMetaHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,gDAAgD;EAChD,wCAAwC;EACxC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;qBACqB;AACrB;;EAEE,cAAc;EACd,gDAAgD;EAChD,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".pills {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  font-family: var(--curio-font-family);\n}\n\n.datasetBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--curio-role-installed-fg);\n  background-color: var(--curio-role-installed-bg);\n  border: 1px solid rgba(47, 143, 74, 0.4);\n  border-radius: var(--curio-radius-pill);\n  padding: 2px 8px;\n  line-height: 1.15;\n  white-space: nowrap;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.datasetBadge:hover {\n  background-color: rgba(47, 143, 74, 0.22);\n  border-color: var(--curio-role-installed-fg);\n}\n\n.datasetBadge:focus-visible {\n  outline: 2px solid var(--curio-role-installed-fg);\n  outline-offset: 1px;\n}\n\n/* Owning node is selected on the canvas — vibrant solid fill that pops against\n   the node header. */\n.datasetBadgeSelected,\n.datasetBadgeSelected:hover {\n  color: #ffffff;\n  background-color: var(--curio-role-installed-fg);\n  border-color: var(--curio-role-installed-fg);\n  box-shadow: 0 0 0 2px rgba(47, 143, 74, 0.35);\n}\n\n.icon {\n  font-size: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pills": `Ba_kLWZwpepDF1xjivhi`,
	"datasetBadge": `BFgYnDQZYyDeH9DBhGMU`,
	"datasetBadgeSelected": `uL6iGMVYFQ59FiY0J3lR`,
	"icon": `OWiS2iuririxKxzOTLQo`
};
export default ___CSS_LOADER_EXPORT___;
